import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, UserRound } from 'lucide-react';
import { AppButton, UserAvatar } from '../../../ui';
import { greeting, localDateKey } from '../trainerDashboardUtils';

/**
 * DashboardGreeting — the page's heading: who is signed in, what today holds,
 * and the two things a trainer does from here that the sidebar does not offer.
 *
 * Props:
 *   profile — { name, avatar, role }
 *   summary — trainerDashboardUtils.daySummary()
 *   now     — the page's clock, so the greeting turns at noon without a reload
 */
const DashboardGreeting = ({ profile = {}, summary, now = new Date() }) => {
  const firstName = (profile.name || '').trim().split(/\s+/)[0] || '';
  const dateLabel = now.toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'long' });

  return (
    <header className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-4">
      <div className="tw-flex tw-min-w-0 tw-items-center tw-gap-3.5">
        <UserAvatar name={profile.name} src={profile.avatar || undefined} size="lg" className="tw-shrink-0" />
        <div className="tw-min-w-0">
          <h1 className="tw-m-0 tw-truncate tw-text-[1.375rem] tw-font-semibold tw-leading-tight tw-tracking-tight tw-text-content">
            {greeting(now)}{firstName ? `, ${firstName}` : ''}
          </h1>
          <p className="tw-m-0 tw-mt-1 tw-text-[0.8125rem] tw-text-content-muted">
            <time dateTime={localDateKey(now)}>{dateLabel}</time>
            {summary && <> · {summary}</>}
          </p>
        </div>
      </div>

      <div className="tw-flex tw-shrink-0 tw-flex-wrap tw-items-center tw-gap-2">
        <AppButton as={Link} to="/i/profile" size="sm" variant="outline">
          <UserRound size={16} aria-hidden="true" /> My profile
        </AppButton>
        <AppButton as={Link} to="/i/batch-assignments/create" size="sm">
          <Plus size={16} aria-hidden="true" /> New assignment
        </AppButton>
      </div>
    </header>
  );
};

export default DashboardGreeting;
